import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextNavSharedComponent } from './text.nav.component';

@NgModule({
    declarations: [
        TextNavSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TextNavSharedComponent
    ]
})

export class TextNavSharedModule {}
